import React, { useCallback, useState } from "react";
import * as css from "./Profile.module.scss";
import { FormattedMessage } from "react-intl";
import ReactMarkdown from "react-markdown";

type ProfileProps = {
  profile: {
    name: string;
    body: string;
  }[];
  lang: `en` | `ja`;
};

const Profile: React.FC<ProfileProps> = (prop) => {
  console.log(prop);

  return (
    <div>
      {/* no1 */}
      <section className={css.profileContent}>
        <div className={css.profileContent__main}>
          {prop.profile.map((profile, i) => {
            return (
              <div className={css.profileItem} key={i}>
                <h3>
                  {prop.lang === "ja" ? (
                    <small>執筆した人: </small>
                  ) : (
                    <small>Text by </small>
                  )}
                  {profile.name}
                </h3>
                {profile.body && (
                  <div>
                    <ReactMarkdown>
                      {profile.body}
                    </ReactMarkdown>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default Profile;
